import React, { useEffect } from "react";

const CoffeeChats = () => {
  // Editable members array — add/remove entries and update Calendly links here
  const members = [
    {
      firstName: "Gui",
      lastName: "Lima",
      title: "Chief Executive Officer",
      calendly: "https://calendly.com/gsl39-georgetown/hoyalytics-coffee-chat",
      description:
        "Gui is a junior in the SFS studying Science, Technology and International Affairs. Outside of Hoyalytics, he is an incoming intern at McKinsey & Company, as well as a Section Editor at Georgetown's Journal of International Affairs. In his free time, he enjoys watching movies, drinking coffee, and traveling.",
      headshotScale: 1.5,
      headshotY: "-5%",
    },
    {
      firstName: "Samantha",
      lastName: "Choung",
      title: "Chief Operating Officer",
      calendly: "https://calendly.com/scc2061-georgetown/hoyalytics-coffee-chats",
      description:
        "Samantha is a senior in the College majoring in Mathematics and Economics and minoring in Chinese. Outside of academics, she enjoys listening to music, baking, and traveling. After graduation, Samantha plans on pursuing a career in wealth management.",
      headshotScale: 1.6,
      headshotX: "3%",
    },
    {
      firstName: "Sam",
      lastName: "Baryessa",
      title: "Chief Analytics Officer",
      calendly: "https://calendly.com/smb450-georgetown/hoyalyticsinterview",
      description:
        "Sam is a senior in the College studying Chinese and Computer Science. He previously interned for the Institute for Critical Infrastructure and Technology. Outside of work and academics, he enjoys cooking, hiking, playing piano, watching international films, and reading.",
      headshotScale: 1.5,
      headshotY: "13%",
    },
    {
      firstName: "Jessica",
      lastName: "Cao",
      title: "Chief Consulting Officer",
      calendly: "https://calendly.com/jkc86-georgetown/hoyalytics?month=2026-08",
      description:
        "Jessica is a junior in the SFS studying Science, Technology, and International Affairs with a Computer Science minor. She has worked at the Massive Data Institute, Toast, Inc., the House of Representatives, and more. She also enjoys vlogging, acting, and reviewing restaurants on Beli..",
    },
    {
      firstName: "Sarah",
      lastName: "Liang",
      title: "Chief Training Officer",
      calendly: "https://calendly.com/sml341-georgetown/hoyalytics-coffee-chats-sarah-liang",
      description:
        "Sarah is a senior in the MSB studying Accounting and Operations & Analytics, with a minor in Spanish. Outside of Hoyalytics, she is a Lead Intern at Georgetown's Business Design and Optimization Group and previously interned at Protiviti. Sarah enjoys running, journaling, playing guitar, and trying new restaurants in her free time.",
        headshotScale: 1.85,
        headshotY: "-2%",
    },
    {
      firstName: "Helen",
      lastName: "Freedman",
      title: "Chief Marketing Officer",
      calendly: "https://calendly.com/hsf19-georgetown/15min?month=2026-08",
      description:
        "Helen is a senior in the College studying Mathematics and English with a concentration in Creative & Public Writing. Previously, she was the Marketing & Recruitment Director for Hoya Taxa and an E-Commerce and Finance Analyst with REUSE. In her free time, Helen enjoys vintage shopping and going on long walks.",
    },
    {
      firstName: "Caleb",
      lastName: "Cole",
      title: "Chief HR Officer",
      calendly: "https://calendly.com/cpc88-georgetown/caleb-coffee-chats",
      description:
        "Caleb is a sophomore at Georgetown studying finance and accounting. Outside of Hoyalytics, he is involved with the Psaros Center for Financial Markets and Policy. In his free time, Caleb enjoys playing tennis, watching movies, and working out.",
    },
  ];

  useEffect(() => {
    // Add a temporary noindex tag while this page is mounted
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div className="coffee-chats-page">
      <header className="coffee-chats-header container">
        <img src="/logo-white.png" alt="Hoyalytics" className="coffee-chats-logo" />
        <h1>Coffee Chat With Hoyalytics</h1>
        <p className="coffee-chats-sub">Meet our Executive Board Members and learn more about Hoyalytics!</p>
      </header>

      <main className="coffee-chats-content">
        <div className="coffee-chats-row-top">
          {members.slice(0, 4).map((member) => {
            const imgSrc =
              "/headshots-2026/" + member.lastName + ", " + member.firstName + ".jpg";
            return (
              <article
                className="coffee-chat-card"
                key={`${member.lastName}-${member.firstName}`}>
                <div className="coffee-chat-headshot">
                  <img
                    src={imgSrc}
                    alt={`${member.firstName} ${member.lastName}`}
                    style={{
                      transform: `translate(${member.headshotX || "0%"}, ${member.headshotY || "0%"}) scale(${member.headshotScale || 1})`,
                    }}
                  />
                </div>

                <div className="coffee-chat-info">
                  <div className="coffee-chat-meta">
                    <h2>{member.firstName + " " + member.lastName}</h2>
                    <h3>{member.title}</h3>
                    {member.description && (
                      <p className="coffee-chat-bio">{member.description}</p>
                    )}
                  </div>
                  {member.calendly ? (
                    <a
                      href={member.calendly}
                      target="_blank"
                      rel="noreferrer"
                      className="coffee-chat-button">
                      Coffee Chat Me
                    </a>
                  ) : (
                    <button className="coffee-chat-button disabled" aria-disabled="true">
                      Coffee Chat Me
                    </button>
                  )}
                </div>
              </article>
            );
          })}
        </div>

        <div className="coffee-chats-row-bottom">
          {members.slice(4).map((member) => {
            const imgSrc =
              "/headshots-2026/" + member.lastName + ", " + member.firstName + ".jpg";
            return (
              <article
                className="coffee-chat-card"
                key={`${member.lastName}-${member.firstName}`}>
                <div className="coffee-chat-headshot">
                  <img
                    src={imgSrc}
                    alt={`${member.firstName} ${member.lastName}`}
                    style={{
                      transform: `translate(${member.headshotX || "0%"}, ${member.headshotY || "0%"}) scale(${member.headshotScale || 1})`,
                    }}
                  />
                </div>

                <div className="coffee-chat-info">
                  <div className="coffee-chat-meta">
                    <h2>{member.firstName + " " + member.lastName}</h2>
                    <h3>{member.title}</h3>
                    {member.description && (
                      <p className="coffee-chat-bio">{member.description}</p>
                    )}
                  </div>
                  {member.calendly ? (
                    <a
                      href={member.calendly}
                      target="_blank"
                      rel="noreferrer"
                      className="coffee-chat-button">
                      Coffee Chat Me
                    </a>
                  ) : (
                    <button className="coffee-chat-button disabled" aria-disabled="true">
                      Coffee Chat Me
                    </button>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      </main>
    </div>
  );
};

export default CoffeeChats;
